import {callsApi} from 'sources/api';

/**
 * Interactions with /coach_me api
 */
export default class CoachMeSource {
  static postCoachMe(fileUpload, coachMe) {
    return callsApi.put(`/calls/${fileUpload.id}/feedback_requested`, {coachMe});
  }
}
